<script>
	import { createEventDispatcher } from "svelte";
	import { slide } from "svelte/transition";
	import { uiText } from "../lib/uiText.js";
	import GeoTracker from "./GeoTracker.svelte";
	export let lang;
	export let taskData;
	export let sessionData;

	let allowTracker = false;

	let tracker;
	let target = taskData.geo_content.coords || false;
	let range = taskData.geo_content.range || false;
	let options = taskData.geo_content.options || {
		enableHighAccuracy: false,
		timeout: 5000,
		maximumAge: 0,
	};

	let distance;

	const dispatch = createEventDispatcher();

	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });

	// console.log(taskData);

	function handleDistance(d) {
		distance = d.detail;
		// console.log(d.detail);
	}
	function handleError(e) {
		// console.log(e.detail.code);
		let erm;
		switch (e.detail.code) {
			case 1:
				erm =
					ui.game.geolocked.error + " " + ui.game.geolocked.error_permission;
				break;
			case 2:
				erm =
					ui.game.geolocked.error + " " + ui.game.geolocked.error_unavailable;
				break;
			case 3:
				erm = ui.game.geolocked.error + " " + ui.game.geolocked.error_timeout;
				break;
			case "BROWSER":
				erm = ui.game.geolocked.error + " " + ui.game.geolocked.error_browser;
				break;
			default:
				erm = ui.game.geolocked.error;
		}
		console.log(erm);

		dispatch("message", {
			msg_content: erm,
			msg_type: "error",
			msg_action: ui.game.riddle.default_action,
		});
	}
</script>

{#if taskData.geo_main}
	<section
		id="geolocked"
		class="grid max-w-5xl pb-8 mx-auto place-content-center {taskData
			.geo_content.geolocked &&
		sessionData?.geoOverwrite !== true &&
		!(distance < range / 1000)
			? 'locked'
			: 'unlocked'}"
	>
		{#if taskData.geo_content.geolocked && sessionData?.geoOverwrite !== true && !(distance < range / 1000)}
			<!-- /* false = this here checks if coords within range */ -->
			<!-- INSIDE IF TRUE -->
			<div class="intro text-center">
				<h1 class=" text-yellow text-center">
					<i class="fa-solid fa-location-pin-lock"></i>
				</h1>
				<h3 class=" text-yellow text-center m-auto">
					{ui.game.geolocked.this_part}
				</h3>
				<p class="text-center m-auto">{ui.game.geolocked.visit_correct}</p>
			</div>
			<br />

			{#if !allowTracker}
				<button on:click={() => (allowTracker = !allowTracker)}
					><i
						class="fa-solid fa-location-crosshairs fa-fw"
						aria-hidden="true"
						data-position="left"
					></i>
					{ui.game.geolocked.permission}</button
				>
				<p class=" text-center opacity-70 m-auto">
					{ui.game.geolocked.disclaimer}
				</p>
			{:else}
				<GeoTracker
					{target}
					{options}
					on:distance={handleDistance}
					on:error={handleError}
				></GeoTracker>
				<br />

				<h3 class="animate-pulse text-center">
					<i class="fa-solid fa-location-crosshairs fa-fw"></i>
					{ui.game.geolocked.tracking}
				</h3>
				<br />
				<p>
					{#if distance}
						{ui.game.geolocked.your_distance}
						{distance > 1
							? Math.round(distance) + " " + ui.global.distance.kilometers
							: Math.round(distance * 1000) + " " + ui.global.distance.meters}
						{ui.game.geolocked.from_target}
						{ui.game.geolocked.closer_unlock}
					{/if}
				</p>
			{/if}
		{:else}
			<div transition:slide>
				<div class="intro text-center">
					<h1 class=" text-yellow text-center">
						<i class="fa-solid fa-compass fa-fw"></i>
					</h1>
					<h3 class=" text-yellow text-center m-auto">
						{ui.game.geolocked.you_unlocked}
					</h3>
					<p class="text-center m-auto">{ui.game.geolocked.stay_around}</p>
				</div>
				<br />

				{@html taskData.geo_main}
			</div>
		{/if}

		{#if taskData.geo_content.showGeoDetails}
			<br />
			<p class=" bg-blue-200 block text-center p-4">
				Precise Distance: {distance * 1000} m, needed: {range} m
				<br />
				High accuracy: {options.enableHighAccuracy}, Timeout: {options.timeout}ms
				<br />
				Target coordinates: {target.latitude}, {target.longitude}
			</p>
		{/if}

		<!-- geo_content{
			 geolocked:true|false (for testing mainly)
				coords:{
					long: ...
					lat: ...
				},
				range: ...
			} -->

		<!-- content -->
	</section>
{/if}

<!-- <div
	class="grid m-[10px] p-[15px] obelisk bg-blue-100 bg-opacity-40 place-content-center place-self-center place-items-center"
>
	<h1 class="text-yellow">{ui.game.bonus_riddle_title}</h1>
	<p class="mb-2">{ui.game.bonus_riddle_description}</p>

	<button
		class="justify-center place-self-center outline"
		on:click={() => dispatch("skipBonus", "skipBonus")}
	>
		<i class="fa-solid fa-ban" data-position="left" />
		{ui.game.bonus_riddle_skip}
	</button>
</div> -->

<!-- <style>
	div {
		border: 2px solid #f7db00;
	}
</style> -->

<style>
	* {
		text-wrap: balance;
	}
</style>
